import React from "react";

import {
  CheckCircleFilled,
  InfoCircleFilled,
} from "@ant-design/icons";

import { getUsageStatusLabel } from "../../utils";

import "./UsageStatusLabel.css";

const STATUS_ICONS = {
  healthy: <CheckCircleFilled />,
  warning: <InfoCircleFilled />,
  critical: <InfoCircleFilled />,
};

export default function UsageStatusLabel({
  status = "healthy",
  used,
  total,
  label,
  variant = "filled",
}) {
  const resolvedStatus = STATUS_ICONS[status] ? status : "healthy";
  const text = label ?? getUsageStatusLabel(resolvedStatus, used, total);

  return (
    <span
      className={[
        "UsageStatusLabel",
        `UsageStatusLabel--${resolvedStatus}`,
        variant === "plain" ? "UsageStatusLabel--plain" : "",
      ].filter(Boolean).join(" ")}
    >
      <span className="UsageStatusLabel__Icon" aria-hidden>
        {STATUS_ICONS[resolvedStatus]}
      </span>
      {text}
    </span>
  );
}
